// extracted by mini-css-extract-plugin
module.exports = {"content":"vacancies_content__qG2o_","title":"vacancies_title__T9CGY","email":"vacancies_email__hcM6b"};